import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { TIMELINE_COPY } from '@sonar-software/sonar-ts-constants';
import { UpdateQueryParams } from '@hooks';
import React, { useCallback } from 'react';

export type SystemChangesFilterParams = { system: boolean};

export interface ChangeCountsFilterProps {
	checked: boolean;
	disabled?: boolean;
	onChange: UpdateQueryParams<SystemChangesFilterParams>;
}

export const SystemChangesFilter: React.FC<ChangeCountsFilterProps> = ({ checked, disabled, onChange }) => {
	const handleOnChange = useCallback((e: CheckboxChangeEvent) => {
		onChange({ system: !e.target.checked });
	}, [ onChange ]);

	return (
		<Checkbox
			checked={ checked }
			disabled={ disabled }
			id='include-system-changes-checkbox'
			onChange={ handleOnChange }>
			{ TIMELINE_COPY.HIDE_SYSTEM_CHANGES }
		</Checkbox>
	);
};
